import React from 'react';
import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const INITIAL_TOUR: OnboardingStep[] = [
    {
        title: 'Welcome to Travelity',
        placement: 'center',
        content: `
                Welcome to Travelity We’re committed to helping your business
                thrive. Let’s take a quick tour to unlock Travelity’s full
                potential. Thank you for choosing us—enjoy the journey!
            `,
        buttonText: 'Let’s Go',
    },
    {
        className: OnboardingClasses.WORKSPACE_TAG,
        title: 'Workspace',
        placement: 'bottom-end',
        padding: 6,
        borderRadius: 24,
        content: (
            <>
                You’re now in your personal workspace, &quot;My Workspace.&quot;
                Travelity uses workspaces to clearly separate the services you
                manage on your own from those you share and collaborate on with
                others.
            </>
        ),
    },
    {
        className: OnboardingClasses.CREATE_PRODUCT_BUTTON,
        title: 'Create Product',
        placement: 'bottom',
        borderRadius: 40,
        content: `
                Products are the services you offer to your customers—like
                tours, transfers, or other experiences. Let’s create your first
                product in Travelity together.
            `,
    },
];
